__turbopack_context__.v({
  "activeBreadcrumb": "breadcrumb-module-scss-module__33KDCG__activeBreadcrumb",
  "breadcrumbsIcon": "breadcrumb-module-scss-module__33KDCG__breadcrumbsIcon",
  "inactiveLink": "breadcrumb-module-scss-module__33KDCG__inactiveLink",
  "link": "breadcrumb-module-scss-module__33KDCG__link",
  "linkWrapper": "breadcrumb-module-scss-module__33KDCG__linkWrapper",
  "mbl": "breadcrumb-module-scss-module__33KDCG__mbl",
  "mbm": "breadcrumb-module-scss-module__33KDCG__mbm",
  "mbn": "breadcrumb-module-scss-module__33KDCG__mbn",
  "mbs": "breadcrumb-module-scss-module__33KDCG__mbs",
  "mbx": "breadcrumb-module-scss-module__33KDCG__mbx",
  "mbxl": "breadcrumb-module-scss-module__33KDCG__mbxl",
  "mbxxl": "breadcrumb-module-scss-module__33KDCG__mbxxl",
  "ml": "breadcrumb-module-scss-module__33KDCG__ml",
  "mll": "breadcrumb-module-scss-module__33KDCG__mll",
  "mlm": "breadcrumb-module-scss-module__33KDCG__mlm",
  "mln": "breadcrumb-module-scss-module__33KDCG__mln",
  "mls": "breadcrumb-module-scss-module__33KDCG__mls",
  "mlx": "breadcrumb-module-scss-module__33KDCG__mlx",
  "mlxl": "breadcrumb-module-scss-module__33KDCG__mlxl",
  "mlxxl": "breadcrumb-module-scss-module__33KDCG__mlxxl",
  "mm": "breadcrumb-module-scss-module__33KDCG__mm",
  "mn": "breadcrumb-module-scss-module__33KDCG__mn",
  "mrl": "breadcrumb-module-scss-module__33KDCG__mrl",
  "mrm": "breadcrumb-module-scss-module__33KDCG__mrm",
  "mrn": "breadcrumb-module-scss-module__33KDCG__mrn",
  "mrs": "breadcrumb-module-scss-module__33KDCG__mrs",
  "mrx": "breadcrumb-module-scss-module__33KDCG__mrx",
  "mrxl": "breadcrumb-module-scss-module__33KDCG__mrxl",
  "mrxxl": "breadcrumb-module-scss-module__33KDCG__mrxxl",
  "ms": "breadcrumb-module-scss-module__33KDCG__ms",
  "mtl": "breadcrumb-module-scss-module__33KDCG__mtl",
  "mtm": "breadcrumb-module-scss-module__33KDCG__mtm",
  "mtn": "breadcrumb-module-scss-module__33KDCG__mtn",
  "mts": "breadcrumb-module-scss-module__33KDCG__mts",
  "mtx": "breadcrumb-module-scss-module__33KDCG__mtx",
  "mtxl": "breadcrumb-module-scss-module__33KDCG__mtxl",
  "mtxxl": "breadcrumb-module-scss-module__33KDCG__mtxxl",
  "mx": "breadcrumb-module-scss-module__33KDCG__mx",
  "mxl": "breadcrumb-module-scss-module__33KDCG__mxl",
  "mxxl": "breadcrumb-module-scss-module__33KDCG__mxxl",
  "parentLinkDiv": "breadcrumb-module-scss-module__33KDCG__parentLinkDiv",
  "pbl": "breadcrumb-module-scss-module__33KDCG__pbl",
  "pbm": "breadcrumb-module-scss-module__33KDCG__pbm",
  "pbn": "breadcrumb-module-scss-module__33KDCG__pbn",
  "pbs": "breadcrumb-module-scss-module__33KDCG__pbs",
  "pbx": "breadcrumb-module-scss-module__33KDCG__pbx",
  "pbxl": "breadcrumb-module-scss-module__33KDCG__pbxl",
  "pbxxl": "breadcrumb-module-scss-module__33KDCG__pbxxl",
  "pl": "breadcrumb-module-scss-module__33KDCG__pl",
  "pll": "breadcrumb-module-scss-module__33KDCG__pll",
  "plm": "breadcrumb-module-scss-module__33KDCG__plm",
  "pln": "breadcrumb-module-scss-module__33KDCG__pln",
  "pls": "breadcrumb-module-scss-module__33KDCG__pls",
  "plx": "breadcrumb-module-scss-module__33KDCG__plx",
  "plxl": "breadcrumb-module-scss-module__33KDCG__plxl",
  "plxxl": "breadcrumb-module-scss-module__33KDCG__plxxl",
  "pm": "breadcrumb-module-scss-module__33KDCG__pm",
  "pn": "breadcrumb-module-scss-module__33KDCG__pn",
  "prl": "breadcrumb-module-scss-module__33KDCG__prl",
  "prm": "breadcrumb-module-scss-module__33KDCG__prm",
  "prn": "breadcrumb-module-scss-module__33KDCG__prn",
  "prs": "breadcrumb-module-scss-module__33KDCG__prs",
  "prx": "breadcrumb-module-scss-module__33KDCG__prx",
  "prxl": "breadcrumb-module-scss-module__33KDCG__prxl",
  "prxxl": "breadcrumb-module-scss-module__33KDCG__prxxl",
  "ps": "breadcrumb-module-scss-module__33KDCG__ps",
  "ptl": "breadcrumb-module-scss-module__33KDCG__ptl",
  "ptm": "breadcrumb-module-scss-module__33KDCG__ptm",
  "ptn": "breadcrumb-module-scss-module__33KDCG__ptn",
  "pts": "breadcrumb-module-scss-module__33KDCG__pts",
  "ptx": "breadcrumb-module-scss-module__33KDCG__ptx",
  "ptxl": "breadcrumb-module-scss-module__33KDCG__ptxl",
  "ptxxl": "breadcrumb-module-scss-module__33KDCG__ptxxl",
  "px": "breadcrumb-module-scss-module__33KDCG__px",
  "pxl": "breadcrumb-module-scss-module__33KDCG__pxl",
  "pxxl": "breadcrumb-module-scss-module__33KDCG__pxxl",
});
